/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './service.defs.js'
export { main as default } from './service.defs.js'
